var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.domainMail)?_c('custom-button',{attrs:{"disable":_vm.isLoading,"type":"link"},on:{"click":_vm.generate}},[_vm._v("\n  "+_vm._s(_vm.$tc(_vm.$translate.GenerateAccesses))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }